<!--
 * @Author: MouXiaowei
 * @Date: 2022-05-24 14:24:02
 * @Description: 邮储银行数字人民币红包活动-首页
-->
<template>
  <div class="home-box">
    <div class="share-box" @click="handleShare">
      <img src="https://oss.aqdpay.com/appweb/modelCreditCard/share.png" alt="">
    </div>
    <div class="input-box">
        <div class="input-box-phone">
            <div class="input-box-title">参与手机号：</div>
            <div class="input-box-value">{{secretMobile}}</div>
        </div>
        <div class="input-box-code">
            <div class="input-box-title">验证码：</div>
            <input name="authcode" type="text" maxlength="6" class="input-box-input" placeholder="请输入验证码" v-model="authcode" @input="inputChange">
            <div v-if="state == 0" class="input-box-send" @click="sendCode">{{btntxt}}</div>
            <div v-else class="input-box-send-gray">{{btntxt}}</div>
        </div>
        <div class="input-box-tip">
            <img v-if="!isAgree" class="agree-img" src="~@/assets/images/unselected.png" @click="handleAgreeSelectedBtn">
            <img v-if="isAgree" class="agree-img" src="~@/assets/images/selected.png" @click="handleAgreeSelectedBtn">
            <div class="agree-text">我已了解活动细则并同意参与</div>
        </div>
        <div class="input-box-btn">
            <img v-if="state == 0" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_uncommitted_btn1_green.png" @click="handleSubmit">
            <img v-else src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_participated_btn1_green.png">
        </div>
    </div>
    <div class="tip-box">
        <p class="tip-box-title">温馨提示：</p>
        <p class="tip-box-value">1.红包到账情况可通过数字人民币APP查看，请在有效时间内使用。</p>
        <p class="tip-box-value">2.近期少数不法分子以“数字人民币交易所”、“获利”、“返现”、“分红”为名进行诈骗。请警惕仿冒APP和仿冒银行信息，谨防不法分子冒充银行和公安机关工作人员骗取信息。</p>
    </div>
    <div class="introduce-box">
        <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_introduce2_green.png">
    </div>
    <div class="explain-box">
        <div class="explain-box-desc">
            <p>1.红包活动报名</p>
            <p>“新客”下载并注册最新版本的便捷青岛APP，点击“邮储银行100万数字人民币红包”活动页面参与活动报名。</p>
            <p>2.下载数字人民币APP，注册开通邮储银行数币钱包领取红包</p>
        </div>
        <div class="explain-box-btn">
            <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_detail_btn1_green.png" @click="gotoOpenExplainPage">
        </div>
        <p>3.领取活动红包并使用</p>
        <div class="explain-box-btn">
            <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_detail_btn1_green.png" @click="gotoRedpaperExplainPage">
        </div>
    </div>
    <div class="rule-box">
        <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_rule2_green.png">
    </div>
    <div class="logo-box">
        <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_logo2.png">
    </div>
    <share-sheet :showShare="showShare" @share="handleShareContent" @cancleShare="handleCancelShare"></share-sheet>
  </div>
</template>
<script>
import { Swipe, SwipeItem, Toast } from 'vant'
import { setStore } from '@/utils/index'
import shareSheet from '@/components/shareSheet'
import { queryPSBCDigiccyRedRet, appointPSBCDigiccyRed, apiSendCode } from '@/api/active'

export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    shareSheet
  },
  data () {
    return {
      showShare: false,
      showType: 0,
      disabled: false,
      time: 0,
      btntxt: '获取验证码',
      phone: '',
      secretMobile: '',
      authcode: '',
      isAgree: false,
      clientType: '',
      redAmount: '', // 红包金额
      isRequesting: false,
      state: 0 // 红包状态：0-未预约,1-预约成功,2-发放成功,3-发放失败
    }
  },
  mounted () {
    const token = this.$route.query.accessToken
    this.clientType = this.$route.query.type
    if (token) {
      setStore('token', token)
    }
    this.queryRedRet()
  },
  methods: {
    queryRedRet () {
      const queryList = {
      }
      queryPSBCDigiccyRedRet(queryList).then(res => {
        if (res && res.data) {
          const datas = res.data.result
          this.phone = datas.mobile
          this.state = datas.state
          this.secretMobile = datas.secretMobile
          this.redAmount = datas.redAmount
        }
      })
    },
    handleSubmit () {
      if (this.isRequesting) {
        return
      }
      if (this.state === 1 || this.state === 2) {
        return
      }
      if (this.authcode == null || this.authcode.length <= 0) {
        Toast({
          message: '请输入短信验证码'
        })
        return
      }
      if (!this.isAgree) {
        Toast({
          message: '请先同意活动细则'
        })
        return
      }
      this.isRequesting = true
      const queryList = {
        authCode: this.authcode,
        clientId: 'dcepred',
        clientType: this.clientType === 'ios' ? '01' : '02'
      }
      appointPSBCDigiccyRed(queryList).then(res => {
        this.isRequesting = false
        if (res && res.data) {
          if (res.data.code === 200) {
            this.$router.push(`/psbcActiveResult?redAmount=${this.redAmount}&secretMobile=${this.secretMobile}`)
          } else {
            Toast({
              message: res.data.result
            })
          }
        }
      }).catch(() => {
        this.isRequesting = false
      })
    },
    sendCode () {
      if (this.disabled) {
        return
      }
      let data = {
        clientId: 'dcepred',
        phone: this.phone
      }
      apiSendCode(data).then((res) => {
        if (res.data.code !== 200) {
          Toast({
            message: res.data.message,
            duration: 1500
          })
        } else if (res.data.code === 200) {
          this.time = 60
          this.disabled = true
          this.timer()
          Toast({
            message: '短信发送成功'
          })
        }
      })
    },
    inputChange () {

    },
    timer () {
      if (this.time > 0) {
        this.time--
        this.btntxt = this.time + 's后再获取'
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.btntxt = '重新发送验证码'
        this.disabled = false
      }
    },
    gotoOpenExplainPage () {
      this.$router.push('/psbcOpenExplain')
    },
    gotoRedpaperExplainPage () {
      this.$router.push('/psbcRedparperExplain')
    },
    handleAgreeSelectedBtn () {
      this.isAgree = !this.isAgree
    },
    // 跳转便捷青岛APP
    goApp () {
      window.location.href = 'bjqd://'
      setTimeout(function () {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
      }, 1200)
    },
    // 分享
    handleShare () {
      this.showShare = true
    },
    handleCancelShare () {
      this.showShare = false
    },
    handleShareContent (type) {
      this.showType = type
      const preFix = window.location.hostname
      console.log(preFix)
      const url = `${preFix}/appweb/psbcActiveShare`
      dsBridge.call('callShareWithType', {
        thirdType: this.showType,
        contentShareType: 3,
        title: '百万数字人民币红包来了！',
        content: '邮储数币新客专享，数量有限先到先得',
        image: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_share.png',
        urlStr: url
      }, function () {})
      this.showShare = false
    }
  }
}
</script>
<style lang="scss" scoped>
.home-box {
  position: relative;
  min-height: 100vh;
  height: 100%;
  background: #97D086 url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_bg2_green.png') no-repeat;
  background-size: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.input-box {
    margin-top: 60%;
    height: 236px;
    width: 336px;
    background: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_border_blank1_green.png') no-repeat;

    .input-box-phone {
        padding-top: 27.5px;
        padding-left: 27.5px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .input-box-title {
        color: #838383;
        font-size: 14px;
        line-height: 20px;
    }
    .input-box-value {
        color: #333333;
        font-size: 16px;
        line-height: 22.5px;
        font-weight: 500;
    }

    .input-box-code {
        padding-left: 27.5px;
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .input-box-input {
            padding-left: 10px;
            height: 31.5px;
            width: 120px;
            background: #FFFFFF;
            border: 1px solid #DBDBDB;
            border-radius: 2.5px;
            color: #333333;
            font-size: 15px;
            outline: none;
        }
        .input-box-send {
            margin-left: 8px;
            color: #1F9EFF;
            line-height: 18.5px;
            font-size: 13px;
            font-weight: 500;
        }
        .input-box-send-gray {
            margin-left: 8px;
            color: #ADADAD;
            line-height: 18.5px;
            font-size: 13px;
            font-weight: 500;
        }
    }

    .input-box-tip {
        margin-top: 16.5px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .agree-img {
            margin-left: 27.5px;
            height: 16px;
            width: 16px;
        }
        .agree-text {
            margin-left: 8px;
            font-size: 13px;
            height: 16px;
            color: #959595;
        }
    }
    .input-box-btn {
        margin-top: 21.5px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}
.tip-box {
    margin: 15px 47px;
    font-size: 12px;
    color: #4B4B4B;
    line-height: 18px;
    &-title {
        margin-bottom: 8px;
        font-weight: bold;
        text-align: center;
    }
}
.introduce-box {
    margin-top: 14.5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    img {
        width: 336px;
    }
}
.explain-box {
    margin-top: 14.5px;
    height: 310px;
    width: 336px;
    background: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_explain1_green.png') no-repeat;
    .explain-box-desc {
        padding-top: 51.5px;
    }
    p {
        margin-left: 15.5px;
        margin-right: 15.5px;
        font-size: 12px;
        color: #64B25C;
        letter-spacing: 0;
        line-height: 18px;
    }
    .explain-box-btn {
        margin-top: 11px;
        margin-bottom: 11px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
}
.rule-box {
    margin-top: 14.5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    img {
        width: 336px;
    }
}
.logo-box {
    margin-top: 44.5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    img {
        width: 100%;
    }
}
.share-box {
  position: absolute;
  top: 1.2%;
  right: 9.5%;
  img {
    width: 24px;
    height: 24px;
  }
}
</style>
